"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
require("react");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const noop_1 = tslib_1.__importDefault(require("lodash/fp/noop"));
const SidebarBackdrop = ({ onClick = noop_1.default, makeBackdropVisible = false, className = '' }) => {
    const backdropClassNames = (0, classnames_1.default)('SidebarBackdrop', makeBackdropVisible && 'sidebar-backdrop-bg', className);
    return (0, jsx_runtime_1.jsx)("div", { className: backdropClassNames, onClick: onClick, "data-testid": 'sidebarBackdrop' });
};
exports.default = SidebarBackdrop;
